import { ContributionPrioritizationTile } from "../ContributionPrioritizationTile.js";

export function ContributionPriorityWidget() {
  return <ContributionPrioritizationTile />;
}
